import { render, staticRenderFns } from "./ChallengeRecordsTab.vue?vue&type=template&id=536b7822"
import script from "./ChallengeRecordsTab.vue?vue&type=script&lang=js"
export * from "./ChallengeRecordsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports